module.exports = __webpack_public_path__ + "media/images/responsive/top/flow_step05-d47903a39a6b44d04cab4b346424c7c3.jpg";